module.exports = __webpack_public_path__ + "static/media/Huaral_256x256px.c05fa2fb.jpg";